var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgKeyIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "M11 10 1 19.77V23h3.23l1.75-1.75V19.5h1.75l.91-.909v-1.817h1.817l.908-.909L14 13"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 7,
  r: 6,
  stroke: "currentColor",
  strokeWidth: 2
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.5,
  cy: 5.5,
  r: 1.5,
  fill: "currentColor"
})));
export default SvgKeyIcon;